import {Button} from '@chekinapp/ui';
import {Trans, useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useFetchIVLottie} from '@chekin/shared';
import {IV_DOCUMENT_IMAGE_TYPES} from '@chekin/core';
import {PATHS} from 'routes/constants';
import MRZPageLayout from '../../MRZPageLayout';
import {StyledLottie, Wrapper} from './styled';

function MRZStartView() {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const {animationData} = useFetchIVLottie({
    type: IV_DOCUMENT_IMAGE_TYPES.front,
    isOCR: false,
  });

  return (
    <MRZPageLayout title={t('guest_data')}>
      <Wrapper className="mrz-start-view">
        <div className="mx-auto mb-[34px] max-w-[430px] px-6 text-center text-[14px] text-[#6C6C6C] min-[480px]:text-[16px]">
          <Trans i18nKey="document_detection_helper_text" />
        </div>
        <StyledLottie animationData={animationData} />
        <div className="mt-auto flex w-full flex-col gap-12">
          <div className="mx-auto flex w-full max-w-[420px] flex-col gap-5 px-6">
            <Button
              className="w-full"
              onClick={() => navigate(`../${PATHS.documentMRZ}/take`)}
            >
              {t('take_a_photo')}
            </Button>
            <Button
              className="w-full"
              onClick={() => navigate(`../${PATHS.documentMRZ}/upload`)}
            >
              {t('upload_file')}
            </Button>
          </div>
        </div>
      </Wrapper>
    </MRZPageLayout>
  );
}

export {MRZStartView};
